export default {
    title: '訂單管理'
}
